import React from "react";
import CashIncentives from "@/components/cash-incentives/CashIncentives";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | Cash Incentive",
};

const CashIncentivesScreen = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <CashIncentives />
    </>
  );
};

export default CashIncentivesScreen;
